import { render, staticRenderFns } from "./ExamInsight.vue?vue&type=template&id=bb297e86"
import script from "./ExamInsight.vue?vue&type=script&lang=js"
export * from "./ExamInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports